import { css } from "@emotion/css";
import { Avatar, Text } from "components";
import React from "react";

type Props = {
  speaker: string;
  text: string;
};
export const TranscriptSpeakerItem: React.FC<Props> = ({ speaker, text }) => {
  return (
    <div style={{ marginBottom: "12px" }}>
      <div
        className={css`
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
        `}
      >
        <div
          className={css`
            margin-right: 8px;
          `}
        >
          <Avatar username={speaker} size="1" />
        </div>
        <Text.BodyXS marginTop={0} marginBottom={0}>
          {speaker}
        </Text.BodyXS>
      </div>
      <div style={{ marginTop: "8px" }}>
        <Text.BodySM color="primary">{text}</Text.BodySM>
      </div>
    </div>
  );
};
